import gsap from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'
import { elementExists } from './shared'

export const runStaggerReveal = ({ container, card }) => {
    if (!elementExists(container)) return

    gsap.registerPlugin(ScrollTrigger)

    const mm = gsap.matchMedia()

    mm.add('(min-width: 768px)', () => {
        gsap.from(card, {
            scrollTrigger: {
                trigger: container,
                start: '30% 80%',
                end: 'bottom 80%',
                once: true,
            },
            y: 40,
            opacity: 0,
            duration: 0.6,
            stagger: 0.12,
            ease: 'back.out(1.4)',
        })
    })

    mm.add('(max-width: 767px)', () => {
        gsap.utils.toArray(card).forEach((el) => {
            gsap.from(el, {
                scrollTrigger: {
                    trigger: el,
                    start: 'top 85%',
                    once: true,
                },
                y: 40,
                opacity: 0,
                duration: 0.6,
                ease: 'back.out(1.4)',
            })
        })
    })
}
